import "./style.scss"
import React from "react"
import RequestDemo from "../../modals/requestdemo/RequestDemo"
import { Button } from "@material-ui/core"

const BookingSection = ({
  howItWorksTitle,
  howItWorks,
  howItworksBtn,
  isContactUsPage,
}) => {
  const [showDemoModal, setShowDemoModal] = React.useState(false)
  const showModal = () => {
    setShowDemoModal(!showDemoModal)
  }
  return (
    <div className="how_it_works">
      {showDemoModal && <RequestDemo show={showDemoModal} onHide={showModal} />}
      <h1 className="title">{howItWorksTitle}</h1>
      <p className="text">{howItWorks}</p>
      {isContactUsPage ? (
        <Button
          variant="contained"
          disableElevation
          href="/contact"
          className="book_demo"
        >
          {howItworksBtn ? howItworksBtn : "Book Demo"}
        </Button>
      ) : (
        <button className="book_demo" onClick={showModal}>
          {howItworksBtn ? howItworksBtn : "Book Demo"}
        </button>
      )}
    </div>
  )
}

export default BookingSection
